import React, { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { CiMobile2 } from "react-icons/ci";
import logo from "../../fourthAssets/Images/logo.png";
import { VscThreeBars } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import allPaths from '../../Config/paths';
import { useDispatch } from 'react-redux';
import { setLanguage } from "../../Redux/actions/languageAction";
import ReactFlagsSelect from 'react-flags-select';
import EnglishFlag from '../../assets/Images/englishFlag.png';
import GermanLanguage from '../../assets/Images/germanLangugae.png';
import ArabicLanguage from '../../assets/Images/arabicLanguage.jpg';
import { menuItems } from "../../fourthUtils/constant";
import { IoCall, IoMail, IoLocation } from "react-icons/io5";

const Header = (props) => {
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [selected, setSelected] = useState('GB');
    const history = useHistory();
    const dispatch = useDispatch();
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english';
    const isAlSelect = language?.language === 'arabic';

    const changeLanguage = (language) => {
        dispatch(setLanguage(language));
    };

    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const toggled = () => {
        setToggle(!toggle);
    };

    const handleNavigation = (path) => {
        history.push(path);
    };

    return (
        <div>
            <div className="frth-des-header-1">
                <h2>
                    {selectedLanguage?.txt_welcome_to_cairo_capital_clinics}
                </h2>
                <div>
                    <button><FaFacebookF /></button>
                    <button><FaInstagram /></button>
                </div>
            </div>
            <div className={isHeaderFixed ? "frth-design-header-fixed" : ""}>
                <div className="frth-des-header-2">
                    <div className="frth-des-header-2-inner-1">
                        <div className="frth-des-header-logo-div">
                            <img src={logo} alt="" />
                        </div>
                        <div className="frth-des-toggle-btn-div" onClick={toggled}>
                            {!toggle ?
                                <VscThreeBars />
                                :
                                <IoMdClose />
                            }
                        </div>
                        <div className="frth-des-header-location-sec">
                            <div>
                                <button><IoCall /></button>
                                <p>0100 0066654</p>
                            </div>
                            <div>
                                <button><IoMail /></button>
                                <p>info@cairocapitalclinics.com</p>
                            </div>
                            <div>
                                <button><IoLocation /></button>
                                <div>
                                    <p>
                                        {selectedLanguage?.txt_3_taha_hussein_street}
                                    </p>
                                    <p>{selectedLanguage?.txt_el_yamama_center_zamalek_cairo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav className="frth-des-header-2-inner-2 frth-des-web-header">
                        <div>
                            <ul className="frth-design-nav">
                                {menuItems?.map((v, i) => (
                                    <li key={i} onClick={() => handleNavigation(v?.menuRoute)}>
                                        <a href="">
                                            {isELSelect ? v?.menuName : (isAlSelect ? v?.menuALName : v?.menuGLName)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <div>
                                <span onClick={() => changeLanguage('english')} >
                                    <img src={EnglishFlag} className="LanguageChange" />
                                </span>
                                <span onClick={() => changeLanguage('arabic')}>
                                    <img src={ArabicLanguage} className="arabicLanguage" />
                                </span>
                                <span onClick={() => changeLanguage('german')}>
                                    <img src={GermanLanguage} className="LanguageChange" />
                                </span>
                            </div>
                        </div>
                    </nav>
                    {toggle ? <nav className="frth-des-header-2-inner-2 frth-des-mob-header">
                        <div>
                            <ul className="frth-design-nav">
                                {menuItems?.map((v, i) => (
                                    <li key={i} onClick={() => handleNavigation(v?.menuRoute)}>
                                        <a href="">
                                            {isELSelect ? v?.menuName : (isAlSelect ? v?.menuALName : v?.menuGLName)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </nav> : null}
                </div>
            </div>
        </div>
    );
};

export default Header;
